import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import './index.css';
import './i18n/config';
import { Provider } from 'react-redux';

import debounce from 'lodash/debounce';
import Store from './redux';
import { saveState } from './services/browserStorage';

// load React Datepicker locales
import { registerLocale, setDefaultLocale } from "react-datepicker";
import it from "date-fns/locale/it"; // the locale you want
import { useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
registerLocale("it", it); // register it with the name you want
setDefaultLocale("it"); // set datepicker locale once

const waitingTime = Number(process.env.REACT_APP_WAITING_TIME) || 800;

Store.subscribe(
  // we use debounce to save the state once each 800ms
  // for better performances in case multiple changes occur in a short time
  debounce(() => {
      saveState(Store.getState());
  }, waitingTime)
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.Fragment>
    <Provider store={Store} >
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
